import React, { Component } from 'react';
import Slider from 'react-slick';
import Schedule from '~/modules/TeamSchedule/Schedule';
import { getGames, isLive, nextGame } from '~/tools/mll/helpers';
import isPast from 'date-fns/is_past';
import axios from 'axios';
import '~/modules/Tray/Article/style.css';
import './styles.css';

class ScheduleTray extends Component {
  state = {
    items: []
  }

  isOngoing = (schedule) => {
    schedule.forEach(s => {
      const time = s.schedule.gameTime * 1000;
      const self = this;
      if (isPast(time) && s.dataId) {
        this[s.dataId] = setInterval(
          function getEvent() {
            axios.get(`/game/boxscore/${s.dataId}/${Date.now()}`)
            .then((res) => {
              const teamstats = res.data.gamescore.boxscore.teamstats;
              const [ away, home ] = teamstats.map(item => item.goals);
              if (isLive('GAME', res.data)) {
                self.setState({ [s.dataId]: [ true, away, home ] })
              } else {
                self.setState({ [s.dataId]: [ false, away, home ] })
                clearInterval(self[s.dataId])
              }
            }).catch((err) => {
              console.log(err);
            })
            return getEvent
          }.call(self), 120000
        )
      }
    })
  }

  componentDidMount = () => {
    getGames().then((res) => {
      // fill empty space with divs
      if (res.length < 6) {
        const init_len = res.length;
        res.length = 6;
        res.fill(0, init_len, 6)
      }
      this.setState({ items: res })
      const initialSlide = nextGame(res)
      this.slider.slickGoTo(initialSlide)
      this.isOngoing(res)
    })
  }

  render() {
    const settings = {
      responsive: [
        { breakpoint: 1400, settings: { slidesToShow: 5, slidesToScroll: 5 } },
        { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 4 } },
        { breakpoint: 1000, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 800, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 400, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ]
    }
    return (
      <div className='schedule-tray-wrapper'>
      { this.state.items.length > 0 && 
        <Slider 
          {...settings}
          ref={(slider) => { this.slider = slider }}
          slidesToShow={6}
          slidesToScroll={6}
          infinite={true}
          arrows={false}
        >
          { this.state.items.map((el, i) => (
            el !== 0 ?
              <div key={i}>
                <Schedule
                  homeTeam={el.homeTeam}
                  awayTeam={el.awayTeam}
                  schedule={el.schedule}
                  ticket={el.ticket}
                  stream={el.stream}
                  link={el.link}
                  live={this.state[el.dataId] && this.state[el.dataId][0]}
                  scores={this.state[el.dataId] && [this.state[el.dataId][1], this.state[el.dataId][2]]}
                />
              </div> :
              <div />
          )) }
        </Slider> }
      </div>
    )
  }
}

export default ScheduleTray
